/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { FlatTaskEvaluationOutput } from './flatTaskEvaluationOutput';
import type { OralExamTaskEvaluationOutput } from './oralExamTaskEvaluationOutput';

export type SubmissionEvaluationAnyOf = FlatTaskEvaluationOutput | OralExamTaskEvaluationOutput;
